/**
 * devLog — gated console.log wrapper.
 *
 * In development: forwards to console.log.
 * In production: no-op (zero cost, nothing leaks to user consoles).
 *
 * Use this for tracking / debugging output. Raw `console.log` is linted
 * to warn so the convention stays consistent. Use `console.warn` /
 * `console.error` directly for genuine error reporting.
 */
export default function devLog(...args) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}
